import cimg1 from '../images/popular/img-1.jpg'
import cimg2 from '../images/popular/img-2.jpg'
import cimg3 from '../images/popular/img-3.jpg'
import cimg4 from '../images/popular/img-4.jpg'
import cimg5 from '../images/popular/img-5.jpg'
import cimg6 from '../images/popular/img-6.jpg'

import cSimg1 from '../images/popular/popular-single/img-1.jpg'
import cSimg2 from '../images/popular/popular-single/img-2.jpg'
import cSimg3 from '../images/popular/popular-single/img-3.jpg'
import cSimg4 from '../images/popular/popular-single/img-4.jpg'
import cSimg5 from '../images/popular/popular-single/img-5.jpg'
import cSimg6 from '../images/popular/popular-single/img-6.jpg'

import author1 from '../images/popular/avater/img-1.jpg'
import author2 from '../images/popular/avater/img-2.jpg'
import author3 from '../images/popular/avater/img-3.jpg'


const Courses = [
   {
      Id: '1',
      cImg: '/assets/images/courses/1.jpg',
      cSImg: '/assets/images/courses/1.jpg',
      author:author1,
      authortitle:'James Thompson',
      lesson:'15',
      fee: '120',
      student:'150',
      ratting:'4.8',
      title: 'Technology & Future Trends',
      slug: 'Technology-&-Future-Trends',
      description: 'Explore cutting-edge technologies and future trends shaping our world.',
   },
   {
      Id: '2',
      cImg: '/assets/images/courses/2.jpg',
      cSImg: '/assets/images/courses/2.jpg',
      author:author2,
      authortitle:'Emma Williams',
      lesson:'20',
      fee: '100',
      student:'200',
      ratting:'4.9',
      title: 'Health & Wellbeing',
      slug: 'Health-&-Wellbeing',
      description: 'Comprehensive health and wellness programs for a better lifestyle.'
   },
   {
      Id: '3',
      cImg: '/assets/images/courses/3.jpg',
      cSImg: '/assets/images/courses/3.jpg',
      author:author3,
      authortitle:'Oliver Davies',
      lesson:'25',
      fee: '90',
      student:'180',
      ratting:'4.7',
      title: 'Education & Career Growth',
      slug: 'Education-&-Career-Growth',
      description: 'Advance your education and accelerate your career development.'
   },
   {
      Id: '4',
      cImg: '/assets/images/courses/4.jpg',
      cSImg: '/assets/images/courses/4.jpg',
      author:author1,
      authortitle:'Sophie Bennett',
      lesson:'18',
      fee: '110',
      student:'220',
      ratting:'4.6',
      title: 'Leadership & Personal Development',
      slug: 'Leadership-&-Personal-Development',
      description: 'Develop leadership skills and personal growth strategies.'
   },
   {
      Id: '5',
      cImg: '/assets/images/courses/5.jpg',
      cSImg: '/assets/images/courses/5.jpg',
      author:author2,
      authortitle:'Harry Mitchell',
      lesson:'22',
      fee: '85',
      student:'160',
      ratting:'4.5',
      title: 'Society, Arts & Culture',
      slug: 'Society-Arts-&-Culture',
      description: 'Explore society, arts, and cultural understanding.'
   },
   {
      Id: '6',
      cImg: '/assets/images/courses/6.jpg',
      cSImg: '/assets/images/courses/6.jpg',
      author:author3,
      authortitle:'Charlotte Hughes',
      lesson:'16',
      fee: '95',
      student:'190',
      ratting:'4.8',
      title: 'Environment & Sustainability',
      slug: 'Environment-&-Sustainability',
      description: 'Learn about environmental protection and sustainable practices.'
   },
   {
      Id: '7',
      cImg: '/assets/images/courses/7.jpg',
      cSImg: '/assets/images/courses/7.jpg',
      author:author1,
      authortitle:'George Harrison',
      lesson:'28',
      fee: '130',
      student:'250',
      ratting:'4.9',
      title: 'Finance & Economy',
      slug: 'Finance-&-Economy',
      description: 'Master financial planning and economic principles.'
   },
   {
      Id: '8',
      cImg: '/assets/images/courses/8.jpg',
      cSImg: '/assets/images/courses/8.jpg',
      author:author2,
      authortitle:'Amelia Clarke',
      lesson:'24',
      fee: '105',
      student:'170',
      ratting:'4.7',
      title: 'Future of Work & HR',
      slug: 'Future-of-Work-&-HR',
      description: 'Understand the evolving workplace and human resources.'
   },
   {
      Id: '9',
      cImg: '/assets/images/courses/9.jpg',
      cSImg: '/assets/images/courses/9.jpg',
      author:author3,
      authortitle:'Jack Robinson',
      lesson:'19',
      fee: '75',
      student:'140',
      ratting:'4.6',
      title: 'Youth & Future Skills',
      slug: 'Youth-&-Future-Skills',
      description: 'Prepare young people with essential future skills.'
   },
   {
      Id: '10',
      cImg: '/assets/images/courses/10.jpg',
      cSImg: '/assets/images/courses/10.jpg',
      author:author1,
      authortitle:'Isabella Taylor',
      lesson:'30',
      fee: '150',
      student:'300',
      ratting:'4.8',
      title: 'Specialized Programs & Events',
      slug: 'Specialized-Programs-&-Events',
      description: 'Specialized training programs and professional events.'
   },
   {
      Id: '11',
      cImg: '/assets/images/courses/11.jpg',
      cSImg: '/assets/images/courses/11.jpg',
      author:author2,
      authortitle:'Thomas Anderson',
      lesson:'26',
      fee: '140',
      student:'210',
      ratting:'4.9',
      title: 'Law, Policy & Governance',
      slug: 'Law-Policy-&-Governance',
      description: 'Understanding legal systems, policies, and governance.'
   },
   {
      Id: '12',
      cImg: '/assets/images/courses/12.jpg',
      cSImg: '/assets/images/courses/12.jpg',
      author:author3,
      authortitle:'Emily Watson',
      lesson:'32',
      fee: '120',
      student:'180',
      ratting:'4.7',
      title: 'Science & Research',
      slug: 'Science-&-Research',
      description: 'Advanced scientific research and methodology training.'
   },
   {
      Id: '13',
      cImg: '/assets/images/courses/13.jpg',
      cSImg: '/assets/images/courses/13.jpg',
      author:author1,
      authortitle:'William Foster',
      lesson:'21',
      fee: '95',
      student:'160',
      ratting:'4.6',
      title: 'Media & Digital Arts',
      slug: 'Media-&-Digital-Arts',
      description: 'Creative media production and digital arts mastery.'
   },
   {
      Id: '14',
      cImg: '/assets/images/courses/14.jpg',
      cSImg: '/assets/images/courses/14.jpg',
      author:author2,
      authortitle:'Grace Murphy',
      lesson:'17',
      fee: '80',
      student:'130',
      ratting:'4.5',
      title: 'Lifestyle & Personal Growth',
      slug: 'Lifestyle-&-Personal-Growth',
      description: 'Transform your lifestyle and achieve personal growth.'
   },
   {
      Id: '15',
      cImg: '/assets/images/courses/15.jpg',
      cSImg: '/assets/images/courses/15.jpg',
      author:author3,
      authortitle:'Henry Campbell',
      lesson:'35',
      fee: '160',
      student:'280',
      ratting:'4.8',
      title: 'Construction & Skilled Trades',
      slug: 'Construction-&-Skilled-Trades',
      description: 'Master construction techniques and skilled trade practices.'
   },
   {
      Id: '16',
      cImg: '/assets/images/courses/16.jpg',
      cSImg: '/assets/images/courses/16.jpg',
      author:author1,
      authortitle:'Lucy Edwards',
      lesson:'23',
      fee: '110',
      student:'190',
      ratting:'4.7',
      title: 'Transport & Logistics',
      slug: 'Transport-&-Logistics',
      description: 'Efficient transport and logistics management strategies.'
   },
   {
      Id: '17',
      cImg: '/assets/images/courses/17.jpg',
      cSImg: '/assets/images/courses/17.jpg',
      author:author2,
      authortitle:'Oscar Phillips',
      lesson:'27',
      fee: '100',
      student:'170',
      ratting:'4.6',
      title: 'Hospitality & Tourism',
      slug: 'Hospitality-&-Tourism',
      description: 'Excellence in hospitality and tourism industry practices.'
   },
   {
      Id: '18',
      cImg: '/assets/images/courses/18.jpg',
      cSImg: '/assets/images/courses/18.jpg',
      author:author3,
      authortitle:'Poppy Collins',
      lesson:'14',
      fee: '90',
      student:'150',
      ratting:'4.8',
      title: 'Beauty & Wellness',
      slug: 'Beauty-&-Wellness',
      description: 'Professional beauty and wellness industry training.'
   },
   {
      Id: '19',
      cImg: '/assets/images/courses/19.jpg',
      cSImg: '/assets/images/courses/19.jpg',
      author:author1,
      authortitle:'Alfie Turner',
      lesson:'29',
      fee: '125',
      student:'200',
      ratting:'4.7',
      title: 'Real Estate & Property Management',
      slug: 'Real-Estate-&-Property-Management',
      description: 'Comprehensive real estate and property management skills.'
   },
   {
      Id: '20',
      cImg: '/assets/images/courses/20.jpg',
      cSImg: '/assets/images/courses/20.jpg',
      author:author2,
      authortitle:'Mia Stewart',
      lesson:'20',
      fee: '85',
      student:'160',
      ratting:'4.5',
      title: 'Arts, Media & Creativity',
      slug: 'Arts-Media-&-Creativity',
      description: 'Unlock your creative potential in arts and media.'
   },
   {
      Id: '21',
      cImg: '/assets/images/courses/21.jpg',
      cSImg: '/assets/images/courses/21.jpg',
      author:author3,
      authortitle:'Freddie White',
      lesson:'25',
      fee: '105',
      student:'180',
      ratting:'4.9',
      title: 'Food & Culinary Skills',
      slug: 'Food-&-Culinary-Skills',
      description: 'Master culinary arts and professional cooking techniques.'
   },
   {
      Id: '22',
      cImg: '/assets/images/courses/22.jpg',
      cSImg: '/assets/images/courses/22.jpg',
      author:author1,
      authortitle:'Evie Moore',
      lesson:'18',
      fee: '75',
      student:'140',
      ratting:'4.6',
      title: 'Family & Parenting Support',
      slug: 'Family-&-Parenting-Support',
      description: 'Essential support and guidance for families and parents.'
   },
   {
      Id: '23',
      cImg: '/assets/images/courses/23.jpg',
      cSImg: '/assets/images/courses/23.jpg',
      author:author2,
      authortitle:'Noah Bailey',
      lesson:'22',
      fee: '95',
      student:'170',
      ratting:'4.7',
      title: 'Sports & Fitness Training',
      slug: 'Sports-&-Fitness-Training',
      description: 'Professional sports and fitness training programs.'
   },
   {
      Id: '24',
      cImg: '/assets/images/courses/24.jpg',
      cSImg: '/assets/images/courses/24.jpg',
      author:author3,
      authortitle:'Isla Richardson',
      lesson:'31',
      fee: '135',
      student:'220',
      ratting:'4.8',
      title: 'Technology & Digital Skills',
      slug: 'Technology-&-Digital-Skills',
      description: 'Essential technology and digital skills for the modern world.'
   },
   {
      Id: '25',
      cImg: '/assets/images/courses/25.jpg',
      cSImg: '/assets/images/courses/25.jpg',
      author:author1,
      authortitle:'Arthur Cooper',
      lesson:'33',
      fee: '145',
      student:'260',
      ratting:'4.9',
      title: 'Business & Entrepreneurship',
      slug: 'Business-&-Entrepreneurship',
      description: 'Build successful businesses and entrepreneurial ventures.'
   }

]

export default Courses;